let cachedVoice: SpeechSynthesisVoice | null = null
let voicesCached = false

function scoreVoice(voice: SpeechSynthesisVoice): number {
  let score = 0
  const name = voice.name.toLowerCase()
  const lang = voice.lang.toLowerCase()

  if (!lang.startsWith('it')) return -1
  score += 100

  if (name.includes('natural')) score += 50
  if (name.includes('online')) score += 40
  if (name.includes('elsa')) score += 25
  if (name.includes('isabella')) score += 30
  if (name.includes('female')) score += 15
  if (name.includes('mobile')) score -= 10
  if (!voice.default) score += 5

  return score
}

function getBestItalianVoice(): SpeechSynthesisVoice | null {
  if (voicesCached) return cachedVoice

  const voices = speechSynthesis.getVoices()
  if (voices.length === 0) return null

  let bestVoice: SpeechSynthesisVoice | null = null
  let bestScore = -1

  for (const voice of voices) {
    const s = scoreVoice(voice)
    if (s > bestScore) {
      bestScore = s
      bestVoice = voice
    }
  }

  cachedVoice = bestVoice
  voicesCached = true
  return cachedVoice
}

if (typeof window !== 'undefined' && 'speechSynthesis' in window) {
  speechSynthesis.getVoices()
  speechSynthesis.onvoiceschanged = () => {
    voicesCached = false
    getBestItalianVoice()
  }
}

function cleanTextForSpeech(text: string): string {
  let clean = text
  // Rimuovi emoji (Unicode emoji ranges)
  clean = clean.replace(/[\u{1F300}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F000}-\u{1F02F}\u{1F0A0}-\u{1F0FF}\u{200D}\u{20E3}\u{FE0F}\u{E0020}-\u{E007F}]/gu, '')
  // Rimuovi tabelle markdown (righe con |)
  clean = clean.replace(/^\|.*\|$/gm, '')
  clean = clean.replace(/^[\s\-|:]+$/gm, '')
  // Rimuovi markdown bold/italic (**, *, __)
  clean = clean.replace(/\*{1,3}(.*?)\*{1,3}/g, '$1')
  clean = clean.replace(/_{1,2}(.*?)_{1,2}/g, '$1')
  // Rimuovi headers markdown (#)
  clean = clean.replace(/^#{1,6}\s*/gm, '')
  // Rimuovi backtick code
  clean = clean.replace(/`{1,3}[^`]*`{1,3}/g, '')
  // Rimuovi bullet points
  clean = clean.replace(/^[\s]*[-*•]\s*/gm, '')
  // Rimuovi link markdown [text](url)
  clean = clean.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
  // Rimuovi righe vuote multiple
  clean = clean.replace(/\n{3,}/g, '\n\n')
  // Trim
  clean = clean.trim()
  return clean
}

export function speakText(text: string, onEnd?: () => void): SpeechSynthesisUtterance | null {
  if (!('speechSynthesis' in window)) return null

  speechSynthesis.cancel()

  const utterance = new SpeechSynthesisUtterance(cleanTextForSpeech(text))
  utterance.lang = 'it-IT'

  const voice = getBestItalianVoice()
  if (voice) {
    utterance.voice = voice
    const isNeural = voice.name.toLowerCase().includes('natural') ||
                     voice.name.toLowerCase().includes('online')
    utterance.rate = isNeural ? 0.85 : 0.78
    utterance.pitch = isNeural ? 1.0 : 1.05
  } else {
    utterance.rate = 0.75
    utterance.pitch = 1.05
  }

  if (onEnd) utterance.onend = onEnd

  speechSynthesis.speak(utterance)
  return utterance
}

export function stopSpeaking(): void {
  if ('speechSynthesis' in window) {
    speechSynthesis.cancel()
  }
}
